<template>
  <div class="social-date-picker multiple-dates">
    <div class="row">
      <div class="col-6 calendar-col">
        <fieldset class="date-time" ref="multiple-datetime">
          <!--
          <b-form-datepicker 
            :id="`social-post-date-${deliverableId}`" 
            :disabled="dateTimeDisabled"
            v-model="postDate"
            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            @input="dateTimeUpdated"
            no-close-on-select="true"
          ></b-form-datepicker>
          -->
          <vuejs-datepicker 
            placeholder="No Date"
            v-model="postDate"
            :highlighted="highlightedDates"
            @input="dateInput"
            @changedMonth="calendarChangedMonth"
            :inline="true"
            :disabled="inputsDisabled"
            calendar-class="multiple-date-calendar"
            ref="multipleDateCalendar"
          />
          <div class="time-wrapper">
          <input type="time" :id="timePickerId"  name="appt"
      	v-model="postTime"
      	:disabled="inputsDisabled"
      	@blur="timeUpdated"
      	/>
      </div>
        </fieldset>
        <div class="footer-controls">
          <b-button variant="primary"  @click="clickAddDates" :disabled="addDatesButtonDisabled">
            Add Dates
            <div role="status" v-show="inputsDisabled" class="ml-2 spinner-border spinner-border-sm text-primary"><span class="sr-only">Loading...</span></div>
          </b-button>
          <b-button variant="secondary" @click="clickCancel" :disabled="inputsDisabled">Cancel</b-button>
        </div>
      </div>
      <div class="col-6 list-col">
        <ul class="multiple-date-list" v-if="dateArray.length">
          <li v-for="date in dateArray">
            <span>{{ getDateListString(date) }}</span>
          </li>
        </ul>
        <h4 v-else>Select one or more dates from the calendar.</h4>
      </div>
    </div>
  </div>
</template>

<script>
import { watch, ref } from 'vue';
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import VueJSDatepicker from "vuejs-datepicker";

export default {
  data() {
    return {
      postDate: "",
      postTime: "",
      dateTimeDisabled: false,
      dateFormat: "YYYY-MM-DD HH:mm:ss",
      timeFormat: "HH:mm:ss",
      dateArray: [],
      currentYear: null,
      currentMonth: null,
      inputsDisabled: false,
    }
  },
  components: {
    "vuejs-datepicker": VueJSDatepicker,
  },
  props: ["deliverableId", "publishDate", "seriesId", "latestPost", "seriesDeliverables"],
  computed: { 
    ...mapGetters([
    "deliverableDetail",
    "systemSettings",
    ]),
    postDateFormatted(){
      return this.$moment(this.postDate).format("YYYY-MM-DD");
    },
    dateIsSet(){
      if(this.dateArray.length){
        return true;
      }
      return false;
    },
    timeIsSet(){
      if(this.postTime.length || this.postTime instanceof Date){
        return true;
      }
      return false;
    },
    addDatesButtonDisabled(){
      if(!this.dateIsSet || !this.timeIsSet || this.inputsDisabled){
        return true;
      }
      return false;
    },
    highlightedDates(){
      if(this.seriesDeliverables !== undefined){
        let that = this;
        let dates = [];
        this.seriesDeliverables.forEach(function(deliverable){
          if(deliverable.publish_date !== null){
            dates.push(
              that.$moment.utc(deliverable.publish_date).local().toDate()
            )
          }
        });
        return {dates};
      }
      return {};
    },
    timePickerId(){
      if(this.deliverableId){
        return "social-post-time-"+this.deliverableId;
      }
      return "social-post-time-multiple-dates";
    },
    utcDateArray(){
      let utcDateTimes = [];
      if(!this.dateArray.length){
        return utcDateTimes;
      }
      // let utcTime = this.$moment(this.postTime).utc().format(this.timeFormat);
      let utcTime = this.$moment(this.postTime, [this.$moment.ISO_8601, this.timeFormat]).utc().format(this.timeFormat);
      this.dateArray.forEach(function(date){
        utcDateTimes.push(date+" "+utcTime);
      });
      return utcDateTimes;
    }
  },
  methods: {
    dateInput(){
      // Update current month and year data
      let date = this.$moment(this.postDate);
      this.currentMonth = date.format("MM");
      this.currentYear = date.format("YYYY");

      if(this.dateArray.includes(this.postDateFormatted)){
        let index = this.dateArray.indexOf(this.postDateFormatted);
        if (index > -1) { // only splice array when item is found
          this.dateArray.splice(index, 1); // 2nd parameter means remove one item only
        }
      } else {
        this.dateArray.push(this.postDateFormatted);
      }

      this.checkSelectedCells();
    },
    async checkSelectedCells(){
      await this.$nextTick();
      let calendar = this.$refs.multipleDateCalendar.$el;
      let that = this;
      $(calendar).find(".cell.day").each(function(i, cell){
        if($(cell).hasClass("selected")){
          $(cell).removeClass("selected");
        }
        if($(cell).hasClass("blank")) {
          return;
        }
        let day = $(cell).html();
        if(day.length === 1){
          day = "0"+day;
        }
        if(that.dateArray.includes(that.currentYear+"-"+that.currentMonth+"-"+day)){
          $(cell).addClass("inarray");
        } else {
          $(cell).removeClass("inarray");
        }
      });
    },
    timeUpdated(){

    },
    calendarChangedMonth(month){
      let date = null;
      if(month instanceof Date){
        date = this.$moment(month);
      } else {
        date = this.$moment(month.timestamp);
      }
      this.currentMonth = date.format("MM");
      this.currentYear = date.format("YYYY");
      this.checkSelectedCells();
    },
    clickAddDates(){
      if(this.dateIsSet && this.timeIsSet){
        this.dispatchPublishDate();
      }
    },
    clickCancel(){
      this.$bvModal.hide("seriesAddMultipleDates");
    },
    dispatchPublishDate(){
      let that = this;
      this.inputsDisabled = true;
      
      let returnId = this.deliverableDetail.id;
      this.$store.dispatch("createSocialSeriesMultipleDates", {
        social_series_id: that.seriesId,
        return_id: returnId,
        values: this.utcDateArray
      }).then(function(){
        that.$bvModal.hide("seriesAddMultipleDates");
      });
    },
    getDateListString(date){
      return this.$moment(date).format("ddd, MMM D YYYY")+" @ "+this.$moment(this.postTime, [this.$moment.ISO_8601, this.timeFormat]).format("h:mm a");
    }
    
  },
  created(){
    if(this.latestPost != undefined){
      let localPublishDate = this.$moment.utc(this.latestPost.publish_date).local().format(this.dateFormat);
      if(localPublishDate != "Invalid date"){
        let localPublishArray = localPublishDate.split(" ");
        this.postTime = localPublishArray[1];
      } else {
        this.postTime = "10:00:00"
      }
    } else {
      this.postTime = "10:00:00"
    }
  }

}
</script>